import { images } from "../shared/Images.js";

function About() {
  return (
    <div className="content-main">
      <div className="container py-4">
        <div className="row">
          <div className="col-lg-12 img-col">
            <img
              src={images.aboutBackground}
              alt="road-transportation"
              title=""
            />
            <div className="section-btn btn-horizontal">
              <a className="btn text-white" href="#">
                About Us
              </a>
            </div>
          </div>
          <div className="col-lg-5 d-flex justify-content-center align-items-center">
            <h2 className="section-title text-secondary">Who are we</h2>
          </div>

          <div className="col-lg-7 text-col align-left">
            <p className="display-7">
              Gauweng SA (Pty) Ltd is a registered 100% black owned and operated
              private company. We specialises in the purchasing of petroleum
              products from wholesalers and/or manufacturers, and selling them
              to petroleum retailers, and the public at a minimum quantities as
              required by the Petroleum Products Act.
            </p>

            <p className="display-7">
              We purchase directly from several leading fuel manufacturers/or
              refineries in South Africa.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
